const MEETING_LOCATION =
    Object.freeze(
        {
            INCALL: 0,
            OUTCALL: 1,
        }
    );

export default MEETING_LOCATION;
